export default {
    cn: {
        login: {
            priceEngine: '交易报表系统',
            login: "登 录",
            loginTxt: '账户名称',
            passwordTxt: '交易密码',
            language: '请选择语言:',
            tips: {
                loginErr: "账号或密码错误",
                disabledUser: "賬號停用",
            }
        }
    },
    hk: {
        login: {
            priceEngine: '交易報表',
            login: "登 錄",
            loginTxt: '帳戶名稱',
            passwordTxt: '交易密碼',
            language: '請選擇語言:',
            tips: {
                loginErr: "帳號或密碼錯誤",
                disabledUser: "賬號停用",
            }
        }
    },
    en: {
        login: {
            priceEngine: 'Dealing Report Engine',
            login: 'Login',
            loginTxt: 'account name',
            passwordTxt: 'passwordTxt',
            language: 'language:',
            tips: {
                loginErr: "An account or password error",
                disabledUser: "Invalid User",
            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/login.js